import { useEffect, useState } from "react";

function format(seconds: number): string {
    return `${Math.floor(seconds / 60)}:${`${seconds % 60}`.padStart(2, "0")}`;
}

/**
 * Seconds left until `expiresAt`, or undefined when there is no deadline.
 * Callers that only want to warn near the end can branch on the number.
 */
export function useSecondsRemaining(expiresAt?: string): number | undefined {
    const [remaining, setRemaining] = useState<number>();

    useEffect(() => {
        if (!expiresAt) {
            setRemaining(undefined);
            return;
        }

        const tick = () => {
            const seconds = Math.round((new Date(expiresAt).getTime() - Date.now()) / 1000);
            setRemaining(Number.isFinite(seconds) ? Math.max(0, seconds) : undefined);
        };
        tick();
        const timer = setInterval(tick, 1000);

        return () => clearInterval(timer);
    }, [expiresAt]);

    return remaining;
}

/**
 * Formats the time left until `expiresAt` as m:ss, or undefined when there is
 * no deadline. Used for the short-lived security transactions.
 */
export function useCountdown(expiresAt?: string): string | undefined {
    const remaining = useSecondsRemaining(expiresAt);

    return remaining === undefined ? undefined : format(remaining);
}
